import { Loader2 } from "lucide-react";
import { GeoKerjaLogo } from "@/components/GeoKerjaLogo";

export function AuthSplash() {
  return (
    <div className="flex min-h-screen w-full items-center justify-center bg-background">
      <div className="flex flex-col items-center gap-4 text-muted-foreground">
        <GeoKerjaLogo />
        <div className="flex items-center gap-2 text-sm">
          <Loader2 className="h-4 w-4 animate-spin" />
          Signing you in…
        </div>
      </div>
    </div>
  );
}
